import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Button, Select } from '@occc-app/design-system';

import {
  InProgressOffersFilterFormProps,
  InProgressOffersFilterFormValues,
  ProgressOfferEligibilityFilterSelectOption,
} from '../in-progress-offers.types';

const eligibilitySelectOptions: ProgressOfferEligibilityFilterSelectOption[] = [
  { label: 'Eligible', value: 'eligible' },
  { label: 'Ineligible', value: 'ineligible' },
];

export const InProgressOffersFilterForm = ({
  onSubmit,
  onReset,
  initialValues,
}: InProgressOffersFilterFormProps) => {
  const renderForm: FormRenderProps<InProgressOffersFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit }: FormRenderProps<InProgressOffersFilterFormValues>) => {
      const reset = () => {
        onReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} py={3} width={300}>
            <Select name='eligibility' label='Eligibility' data={eligibilitySelectOptions} />
          </Box>
          <Box display='flex' justifyContent='flex-end' px={3} pb={2}>
            <Button size='small' color='error' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              Apply
            </Button>
          </Box>
        </form>
      );
    },
    [onReset],
  );
  return (
    <Form<InProgressOffersFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
